import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ICommitProductsToManufacturingPayload {
    designID: number;
    mItemID: number;
}

async function commitProductsToManufacturing(
    payload: ICommitProductsToManufacturingPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/CommitProductsToManufacturing",
        payload,
    );
    return response.data;
}

export function useCommitProductsToManufacturing() {
    return useMutation({
        mutationFn: commitProductsToManufacturing,
    });
}
